import { render, staticRenderFns } from "./GoBack.vue?vue&type=template&id=0e9632a2&scoped=true&"
import script from "./GoBack.vue?vue&type=script&lang=js&"
export * from "./GoBack.vue?vue&type=script&lang=js&"
import style0 from "./GoBack.vue?vue&type=style&index=0&id=0e9632a2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e9632a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e9632a2')) {
      api.createRecord('0e9632a2', component.options)
    } else {
      api.reload('0e9632a2', component.options)
    }
    module.hot.accept("./GoBack.vue?vue&type=template&id=0e9632a2&scoped=true&", function () {
      api.rerender('0e9632a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GoBack/GoBack.vue"
export default component.exports